import { WriteContractor } from "@/types/contractor";

export const defaultContractorValues: WriteContractor = {
  email: "",
  first_name: "",
  last_name: "",
  personal_id_number: "",
  birth_date: "",
  gender: "male",
  phone_number: "",
};
